const InKindDonationStatus = Object.freeze({
  PLEDGED: 'pledged',
  DELIVERED: 'delivered',
  DELIVERY_CONFIRMED: 'delivery-confirmed',
  REJECTED: 'rejected',
});

const InKindDonationDeliveryMethod = Object.freeze({
  IN_PERSON: 'in-person',
  ONLINE_OR_POSTAL: 'online',
});

export {
  InKindDonationStatus,
  InKindDonationDeliveryMethod,
};